import React, { useState } from "react";
import axios from "axios";


const useFile = ({
    getApi = '/component/file',
    onFinish = ({ axiosMode, status, values }) => { },
    onBefore = ({ axiosMode, status }) => { },
}) => {
    const [data, setData] = useState([])
    const getFileData = (params) => {
        onBefore({
            axiosMode: "get"
        })
        return axios.get(getApi, {
            responseType: 'blob',
            params: params,
        })
            .then((response) => {
                let data = response.data
                setData(data)
                if (data) {
                    onFinish(
                        {
                            axiosMode: "get",
                            status: "success",
                            values: data
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "get",
                            status: "error"
                        }
                    )
                }

                return data
            });
    }
    const postFileData = ({
        data,
        fileMode
    }) => {
        const formData = new FormData();
        formData.append('inputFile', data);
        onBefore({
            axiosMode: "post"
        })
        axios.post('/component/file', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                // console.log('responseData', responseData)
                if (status === "fail") {
                    onFinish(
                        {
                            axiosMode: "post",
                            status: "error"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "post",
                            status: "success",
                            values: responseData,
                            fileMode: fileMode
                        }
                    )
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "post",
                        status: "error"
                    }
                )
            })

    }
    const patchFileData = (data) => {
        onBefore({
            axiosMode: "patch"
        })
        axios.patch('/component/file',
            data

        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status === "fail") {
                    onFinish(
                        {
                            axiosMode: "patch",
                            status: "error"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "patch",
                            status: "success"
                        }
                    )
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "patch",
                        status: "error"
                    }
                )
            })
    }
    const deleteFileData = (data) => {
        onBefore({
            axiosMode: "delete"
        })
        axios.delete('/component/file',
            {
                data
            }
        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status === "fail") {
                    onFinish(
                        {
                            axiosMode: "delete",
                            status: "error"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "delete",
                            status: "success"
                        }
                    )
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "delete",
                        status: "error"
                    }
                )
            })
    }
    return {
        FileData: data,
        getFileData,
        postFileData,
        patchFileData,
        deleteFileData,
    }
}
export { useFile }
